<template>
  <component
    :is="tag"
    :class="{...buttonClasses, ...classes}"
    v-bind="$attrs"
    :type="this.$attrs.type || 'button'"
    v-on="$listeners"
  >
    <template v-if="isLoading">
      <span>Loading...</span>
    </template>
    <template v-else>
      <i v-if="icon" class="material-icons" aria-hidden="true">{{ icon }}</i>
      <span v-if="!iconOnly">
        <slot />
      </span>
    </template>
  </component>
</template>

<script>
import buttonMixin from '@/mixins/button';

export default {
  name: 'TrekButton',
  mixins: [buttonMixin],
  inheritAttrs: false,
  props: {
    /**
     * "button" | "input"
     */
    tag: {
      type: String,
      default: 'button',
      validator: (value) => {
        return ['button', 'input'].indexOf(value) !== -1;
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'button--loading': this.isLoading,
        'button--disabled': this.$attrs.disabled,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
